import { Component, OnInit , Inject,ElementRef,ViewChild, AfterViewInit, ViewContainerRef, Renderer , PipeTransform} from '@angular/core';
import { FormArray, FormBuilder, FormsModule, FormGroup, Validators } from '@angular/forms';
import {Location , DatePipe} from '@angular/common';
import { Http, Response } from '@angular/http';
import {environment} from '../../environments/environment.prod';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { DataService } from '../data.service';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { Meta, Title , DomSanitizer , SafeUrl} from "@angular/platform-browser";
import {ViewEncapsulation} from '@angular/core';
import {HomeComponent} from '../home/home.component';
import Vimeo from '@vimeo/player';

declare var jquery: any;
declare var $: any;
declare var System: any;
declare var require:any;
declare var window: any;
declare var fbq: any;
@Component({
  selector: 'app-module-page',
  templateUrl: './module-page.component.html',
  styleUrls: ['./module-page.component.css','./styles.css','./icons.css'],
  encapsulation:ViewEncapsulation.None,

  //directives: [Rating]
})


export class ModulePageComponent implements OnInit , AfterViewInit{

@ViewChild('tabbar') el:ElementRef;
@ViewChild('myButton') myButton;
@ViewChild('videoscroll')
private ele:ElementRef

  pager = {
    index: 0,
    size: 1,
    count: 1
  };
  coachingModuleData: any = [];
  imagePath: string;
  baseUrl: string = 'https://www.youtube.com/';
  moduleId: number;
  name: string;
  benefit: string;
  introduction: string;
  presentedBy: string;
  poweredBy: string;
  poweredBy_Link: string;
  image: string;
  videoLink: any;
  pdfUpload: any;
  quiz: any;
  viewCounter: string;
  averageScore: any;
  pdfUploadFoeNewTab: any;
  isPdf:boolean;
  isQues:boolean;

  moreDetail: any[]=[];
  selected: boolean = false;
  quizScore: number = 100;
  QuestionDetails: any = [];
  summaryFile: string;

  titleStyles: any;
  borderRadius: any;
  rForm: FormGroup;
  moduleRating: number = 1;
  assignRating: number = 5;
  loginUserId: number = -1;


  PerformancePercentage: number = 0;
  CompletedModule: number = 0;
  loginUserName: string = '';
  introselected: boolean = true;
  videoselected: boolean = false;
  pdfselected: boolean = false;
  quizselected: boolean = false;
  reflectselected: boolean = false;
  resultselected: boolean = false;
  moreselected: boolean = false;
  totalScore: number;
  isPricingModal: boolean = false;
  pricinginfo:FormGroup;
  happcoachHostUrl: string;
  isLike: boolean = false;

  btnReflect: boolean= true;
  btnResult: boolean= true;
  btnQuiz: boolean = false;
  currentUrl :string;
  isModuleFree: boolean=true;

  toggleSM: boolean=false;
  isVideoWatch: boolean = false;
  isPdfWatch: boolean = false;
  moduleCompeltedByUser :any;
  public doughnutChartLabels: string[] = ['Score'];
  public doughnutChartData: number[] = [1];
  public questionData: number[]= [5];
  public doughnutChartType: string = 'doughnut';
  public colors: any = [{
    backgroundColor: ['#F9C623'],
    borderColor: ['#F9C623'],
  }];
  public options: any;
  private sub: any;
  startDate : string=" ";
  endDate: string=" ";
  isAssigned: boolean = false;

  //Thakur 22 sep for result
  //total avg score of module
  _mTotalAvgScore: any;
  _mAvgOptions: any;
  _mAvgdoughnutChartLabels: string[] = ['Module Average Score'];
  _mAvgdoughnutChartData: number[] = [1];
  _mAvgdoughnutChartType: string = 'doughnut';


  //user module comoleted
  public mcLabel: string[] = ['Comoleted Modules'];
  public mcData: number[] = [1];
  public mcChartType: string = 'doughnut';
  public mcOptions: any;
  totalModule: number=0;
  isUserModal:boolean=false;
  DetailofModuleData:any[]=[];
  isBadge:boolean=false;
  shareIt:boolean=false;
  isModuleLike:boolean=false;
  isCompleted:boolean=false;
  optionLength : any = 0;
  isShareOptions:boolean=false;
  moduleLikeIndex:number=-1;
  moduleShareIndex:number=-1;
  myarr:any[]=[];
  isMenu:boolean=false;
  responseMessage:string="";
  myurl:string="whatsapp://send?text=http://happcoach.com/PilotServices/Module/"+this.moduleId+".html";
  ChapterId:number=0;
  hideit:boolean=false;
  paddClass:boolean=false;
  paddingCoaching:boolean=false;
  currentDate:string="";
  thumbShare:boolean=false;
  descLink:string="";
  shareLink:string="";
  imageFullLink:string="";

  type:string="";
  isShareMenu:boolean=false;
  isLink:boolean=true;
  shareModuleId:number=-1;
  arr=Array;
  selectGoals:boolean=false;
  goalsCommitted:boolean=false;
  myGoals:boolean=false;
  areaFeedback:boolean=false;
  planForGoals:boolean=false;
  actionPlan:boolean=false;
  goals:any[]=[];
  selectedGoals:any[]=[];
  goalCounter:number=0;
  planData:any[]=[];
  committedModal:boolean=false;
  isLoading:boolean=true;
  hasSummary:boolean=false;
  badgeUnlocked:boolean=false;
  ratingsModal:boolean=false;
  timelineModal:boolean=false;
  isReflect:boolean=false;
  noSlider:boolean=false;
  isHappyHover:boolean=false;
  isSadHover:boolean=false;
  userTypeId:number=-1;
  isNext:boolean=false;
  planId:number=-1;
  seeMoreSm=false;
  seeMoreLg=false;
  seeMoreTrendingSm=false;
  seeMoreTrendingLg=false;
  noTrendingSlider:boolean=false;
  videoNotReady:boolean=true;
  freeTag:boolean=false;
  guestUser:Guest;
  isGuestSignUpModal:boolean=false;
  userUpdated:boolean=false;

  constructor(

    private fb: FormBuilder,
    private activeRouter: ActivatedRoute,
    private _router: Router,
    private service: DataService,
    private location: Location,
    private renderer: Renderer,
    public meta: Meta,
    private ElementRef: ElementRef,
    private title: Title,
    private sanitizer:DomSanitizer,
    private home:HomeComponent,

  ) {
    sessionStorage.removeItem("UserDashboard");
    if(localStorage.getItem("UserId") != null){
      this.loginUserId = parseInt(localStorage.getItem("UserId"))
    }
    this.sub = this.activeRouter.params.subscribe(params => {
      this.name = params['name'];
      this.moduleId = +params['id']; // (+) converts string 'id' to a number
      this.title.setTitle('Stratgist | Module -'+ this.name);
    });
    if(localStorage.getItem("loginUserData")!=null){
      let loginuserdata =   JSON.parse(localStorage.getItem("loginUserData"));
        this.moduleCompeltedByUser=loginuserdata.ModuleCompleted
    }

    this.imagePath = environment.imagePath;
    this.happcoachHostUrl = environment.happCoachUrl;
    this.currentUrl = this._router.url;

    if(sessionStorage.getItem("SignUpUser") != null){
      const userData = JSON.parse(sessionStorage.getItem("SignUpUser"));
      this.loginUserName = userData['FirstName']+" "+userData['LastName'];
    }

    this.rForm = fb.group({
      "Goals1": "",
      "Goals2": "",
      "Goals3": "",
      'UserRating': [5]
    });

    this.pricinginfo=this.fb.group({
      'pricing':['', Validators.required],
      'couponCode': ['']
    });



  }

  ngOnInit() {
      $(window).scrollTop(0);
    var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
           this.paddClass=false;// Chrome

        } else {
           this.paddClass=true;// Safari

        }
      }
      else{
          this.paddClass=false;


      }
    // let global = this.renderer.listen('document', 'click', (evt) => {
    //  // console.log('Clicking the document', evt);
    // })
    //  if(sessionStorage.getItem('CurrentUserId') !== null){
        this.showtip();
        this.tab();

        this.getModuleDeatil();
        if(this.loginUserId != -1){
          this.getDashBoardModuleV2();
        }
        this.getTrendingModule();
        // this.coachingModule();
        this.questionScore(100);
      // }else{
      //   this.service.alert("Please Login/Sign Up to continue","info");
      //    window.location.href = this.happcoachHostUrl+'/login';
      // }
    //  window.setInterval(()=>{
    //    this.blinkTextForButton()
    //  },1000);
    this.descLink=this._router.url;
    this.shareLink="https://stratgist.com/workSmarts"+this._router.url;
      // this.shareLink="https://stratgist.com/coaching-module"+this._router.url;
   // console.log(this.shareLink);

    this.imageFullLink=this.imagePath+"/"+sessionStorage.getItem('imageUrl');
    this.imageFullLink=this.imageFullLink.replace(/ /g,"%20");
   // console.log(this.imageFullLink);
    this.descLink=this.descLink.replace(/%20/g,'%2520');
    // this.descLink=this.descLink.replace('/','%2F');
    this.descLink="%0A%0Ahttps://stratgist.com/workSmarts"+this.descLink;
   // console.log(this.descLink);
    this.getGoals();
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    console.log("onInIt", this.planId);
    setTimeout(()=>{
      this.clickOnPaidModule();
    },500)

  }


  openInNewTab(){
    window.open(this.pdfUploadFoeNewTab, '_blank');
  }



  //Hk for reflect total averageScore

  reflectScore() {
    //My Score
    if(this.PerformancePercentage >= 1){
      this.totalScore = 100 - this.PerformancePercentage;
      this.doughnutChartData = [this.PerformancePercentage];
    }else{
      this.totalScore = 90;
    }
    this.options = {
      cutoutPercentage: 30, //this.totalScore,
      elements: {
        center: {
          text: Math.round(this.PerformancePercentage) + "%",
          fontColor: 'black',
          fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          fontSize: 20,
          fontStyle: 'normal'
        }
      },
      tooltips: {
          enabled: false
      }
    };
    //My Module completed
    // this.totalModule = sessionStorage.getItem("totalModules");
    this.mcData = [parseInt(this.moduleCompeltedByUser)];
    const d = 100 - 100/this.totalModule*parseInt(this.moduleCompeltedByUser);
    this.mcOptions = {
      cutoutPercentage: d,
      elements: {
        center: {
          text: this.moduleCompeltedByUser+"/"+ this.totalModule,
          fontColor: 'black',
          fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          fontSize: 24,
          fontStyle: 'normal'
        }
      },
      tooltips: {
          enabled: false
      }
    };

    //Moudule avg score
    this._mAvgdoughnutChartData = [this.averageScore];
    if(this.averageScore > 0){
      this._mTotalAvgScore = 100 - parseInt(this.averageScore);
    }else{
      this._mTotalAvgScore = 100-90;
    }
    this._mAvgOptions = {
      cutoutPercentage: this._mTotalAvgScore,
      elements: {
        center: {
          text:   parseInt(this.averageScore)+" %",
          fontColor: 'black',
          fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          fontSize: 20,
          fontStyle: 'normal'
        }
      },
      tooltips: {
          enabled: false
      }
    };
  }



  getModuleDeatil() {
    this.setTabActive(1);
      let inputData = { ModuleId: this.moduleId, UserId: this.loginUserId};
    if(this.loginUserId==-1){
      if(sessionStorage.getItem('Guest')==null){
        inputData = { ModuleId: this.moduleId, UserId: this.loginUserId};
      } else {
        this.guestUser=JSON.parse(sessionStorage.getItem('Guest'));
        inputData = { ModuleId: this.moduleId, UserId: this.guestUser['guestUserId']}
      }
    }

   // console.log(inputData);

    // Harkamal Singh 19 Jan 2018 : Service moduledetailsv3
    // this.service.getModuleDetail(inputData)

    this.service.getModuleDetail(inputData)
      .subscribe(
      (response: Response) => {
        this.isLoading=true;
        if (response['Status'] == 'Success') {

          const module = response['DetailofModuleData'][0];
          this.DetailofModuleData.push(module);
         // console.log(this.DetailofModuleData[0]['Summary']);
         // console.log(module);
         // console.log(module['Vediolink']);
          this.isPdf = module['IsPdf'];
          this.isQues = module['IsQusn'];
          this.name = module['Name']
          this.benefit = module['HowBenefit'];
          this.introduction = module['Introduction'];
          this.presentedBy = module['PresentedBy'];
          this.poweredBy = module['PoweredBy'];
          this.poweredBy_Link = module['PoweredBy_Link'],
          this.image = module['Img'];
          this.videoLink = this.getYouTubId(module['Vediolink']);
          this.pdfUpload = this.sanitizer.bypassSecurityTrustResourceUrl(environment.summaryPath+"/"+ module['PdfUpload']);
          this.pdfUploadFoeNewTab = environment.summaryPath+"/"+ module['PdfUpload'];  
          // this.quiz = module['GetQuesn'];
          // this.pager.count = module['GetQuesn'].length;
          // this.PerformancePercentage = module['UserModuleDetails'].length> 0 ?Math.round( module['UserModuleDetails'][0]['Score'] ):0;
          // this.averageScore = module['UserModuleDetails'].length> 0 ?Math.round( module['UserModuleDetails'][0]['UserAvg'] ):0;
          this.CompletedModule = module['CompletedModule'];
          this.moreDetail = module['GetMoreLinkData'];
          this.viewCounter = module['ViewCounter'];
          this.summaryFile = environment.summaryPath+"/"+ module['Summary'];
          this.hasSummary=module['Summary'].length==0 ? false : true;
          this.isCompleted=module['IsCompleted'];
          this.moduleRating=module["ModuleRating"];
          this.startDate = module['StartDate'];
          this.currentDate=module['CurrentDate'];
          this.endDate = module['EndDate'];
          this.isAssigned = module['IsAssigned'];

          this.isModuleFree = module["IsFree"];
          if(this.isModuleFree==false){
             // fbq('track', 'Lead');
          }
          this.ChapterId = module['ChapterId'];
         // console.log(this.startDate);
          this.currentDate=this.formatCtDt();
         // console.log(this.image);
          sessionStorage.setItem('imageUrl',this.image);

          if(this.isCompleted==false){
              this.getQusetionData();
            this.btnQuiz=false;
            this.btnReflect = true;
            this.btnResult = true;
            this.getResultData();
          }
          else {

            this.btnQuiz=false;
            this.btnReflect = false;
            this.btnResult = false;
            this.PerformancePercentage=0;

          }

            this.isLoading=false;
        } else {
         // console.log(response['Message']);
        }
      },
      (error) => {
       // console.log(error);
      },
      ()=>{

      }
      )
  }

  isWrongAns: boolean = false;
  attempt: number = 3;
  get filteredQuestions() {
    if(this.quiz){
      return (this.quiz) ?
         this.quiz.slice(this.pager.index, this.pager.index + this.pager.size) : [];
       }
  }

  goTo(index: number, pvarLen?) {
      this.individualQScore=0;
      this.isWrongAns=false;
      this.quizScore = 100;
      this.isBadge=false;
      this.isQuestion = true;
      this.questionScore(this.quizScore);
      if (index >= 0 && index < this.pager.count) {
        this.pager.index = index;
      }
  }
  scoreModule: boolean = false;
  showScoreModal(){
    this.scoreModule = true
    setTimeout(()=>{
      this.scoreModule = false;
    },3000)
  }

  noOfOptions = 0;
  q: any = -1
  individualQScore: any = 0;
  isQuestion: boolean = true;
  //On petion select function
  onSelect(question, option, questionId, e) {
    var correctOption = "";
    if(this.q != questionId){
      this.attempt = question.OptionData.length-1;
      this.q = questionId;
    }
    this.noOfOptions = question.OptionData.length;

    question.OptionData.forEach((x) => {
      if(x.IsAnswer == true){
        correctOption = x.Opt;
      }
      if (x.OptId !== option.OptId) {
        x.IsSelected = false;
      }
      if(x.OptId == option.OptId){
        x.IsChecked = true;
      }
    });

    if (e.target.checked == true) {
      if (option.IsAnswer == true) {
        this.isWrongAns=false;
        this.quizScore = this.quizScore; //this.quizScore == 0 ? 100 : this.quizScore;
        const quizScore = {
          "ModuleQuesId": questionId,
          "Score": this.quizScore
        };
        this.QuestionDetails.push(quizScore);
        this.questionScore(this.quizScore);
        this.isBadge=true;
        this.isQuestion = false;
        this.individualQScore = this.quizScore;
        //total question length != toal index
        this.service.alert("Bingo! That's the correct answer.", "info");
        // this.showScoreModal();
        if (this.pager.count != this.pager.index + 1) {
          setTimeout(() =>{
            this.goTo(this.pager.index + 1, this.noOfOptions);
          },1000);
        }else{
          this.btnReflect = false;
          setTimeout(() =>{
           // console.log('in submit reflect');
            this.submitReflect(this.rForm.value,true);
          if(this.isReflect==true){
            this.setTabActive(4);
          } else {
            this.setTabActive(5);
          }
            this.btnQuiz = false;
          },2000);
        }
      } else {
        this.isWrongAns = true;
        if(this.noOfOptions == 2){
         // console.log("2 options score "+this.quizScore);
          this.quizScore = this.quizScore - 100;

        }

        if(this.noOfOptions == 3){
          if(this.attempt == 2){
            this.quizScore = this.quizScore - 50; //this.quizScore == 0 ? 100 - 25 : this.quizScore - 25;
          }
          if(this.attempt == 1){
            this.quizScore = this.quizScore - 50; //this.quizScore == 0 ? 100 - 25 : this.quizScore - 25;
          }
        }

        if(this.noOfOptions == 4){
          if(this.attempt == 3){
            this.quizScore = this.quizScore - 50; //this.quizScore == 0 ? 100 - 25 : this.quizScore - 25;
          }
          if(this.attempt == 2 || this.attempt == 1){
            this.quizScore = this.quizScore - 25;
           // console.log(this.quizScore);
          }
        }

        this.attempt = this.attempt != 0 ? this.attempt -1 : 0;
        //this.service.alert("Sorry, wrong answer. You have " +this.attempt+" more attempts left.","error");

        if(this.attempt == 0){ //If user last attempt then move to next   question
          //this.service.alert("You have exhausted all your attempts. Correct asnwer is <b>" + correctOption +"</b>", "info");
          // this.service.alert("You have exhausted all your attempts. You might want to view the video again. <b>" + correctOption +"</b>", "info");
          this.service.alert("You have exhausted all your attempts. You might want to view the video again.", "info");

          this.isBadge=true;
          this.isQuestion = false;
          this.quizScore = this.quizScore;
          const quizScore = {
            "ModuleQuesId": questionId,
            "Score": this.quizScore
          };
          this.QuestionDetails.push(quizScore);
          this.questionScore(this.quizScore);
          //total question length != toal index

          setTimeout(() =>{
            if (this.pager.count != this.pager.index + 1) {
              this.goTo(this.pager.index + 1, this.noOfOptions);
            }else{
              this.submitReflect(this.rForm.value,true);
              this.btnReflect = false;
              if(this.isReflect==true){
                this.setTabActive(4);

              } else {
                this.setTabActive(5);
              }
              this.btnQuiz = false;
            }
          },2000);
        }else{
            var attemptText = "attempt";
            if(this.attempt > 1){
              attemptText = "attempts";
            }
            this.service.alert("Oops! Please try again. You have " +this.attempt+" more "+ attemptText +" left.","error");
            //this.service.alert("Sorry, wrong answer. You have " +this.attempt+" more attempts left.","error");
            this.questionScore(this.quizScore);
        }

      }
    }

  }

  questionTotalScore: number = 0;
  questionOptions: any;

  questionScore(pvarScore){
    //this.questionData = [20];
   // console.log(pvarScore);

    this.questionTotalScore = 80, //100 - pvarScore;
    this.questionOptions = {
      cutoutPercentage: this.questionTotalScore,
      elements: {
        center: {
          text: 30,//pvarScore+"%",
          fontColor: 'black',
          fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          fontSize: 20,
          fontStyle: 'normal',
          backgroundColor:'rgba(255, 99, 132, 1)',
          showTooltips: false,
          responsive: true
        }
      },
      tooltips: {
          enabled: false
      }
    };
  }

  //thakur on:7Nov2017 for submit Reflects
  submitReflect(formValues,fromQuiz?:boolean) {
    this.ratingsModal=false;
   // console.log(this.PerformancePercentage);
   // console.log(formValues);

    if(fromQuiz==undefined){
      if(formValues.UserRating==0) {
        this.service.alert("Please rate this module","error");
        return false;
      }

        if(this.isCompleted ==true ){
         // console.log(this.PerformancePercentage);

                const inputData = {
                  "Islike": this.isLike,
                  "ModuleId": this.moduleId,
                  "UserId": this.loginUserId==-1 ? this.guestUser.guestUserId : this.loginUserId,
                  "UserRating": formValues.UserRating,
                };

               // console.log(inputData);
                this.service.updateReflection(inputData)
                      .subscribe(
                        (response) => {
                          if (response['Status'] == 'Success') {
                            //this.service.alert("Updated successfully!" ,"success");
                            this.btnResult = false;
                            if(sessionStorage.getItem('Guest')!=null){
                              this.isGuestSignUpModal=true;
                            }
                            // this.setTabActive(5);
                          } else {
                            this.service.alert(response['Message'],"error");
                          }
                        },
                        (error) => {
                         // console.log(error);
                        }
                      )
        }
        else {
          this.isLoading=true;
         // console.log(this.QuestionDetails);
                  const inputData = {
                    "IsPaid":parseInt(localStorage.getItem("planId"))==-1 ? false : true,
                    "Islike": this.isLike,
                    "ModuleId": this.moduleId,
                    "QuestionDetails": this.QuestionDetails,
                    "UserId": this.loginUserId==-1 ? this.guestUser.guestUserId : this.loginUserId,
                    "UserRating": formValues.UserRating,
                    "IsTestUser":(this.guestUser==null || this.guestUser==undefined) ? false : true
                  };
                 // console.log(inputData);
                  this.service.SaveModuleDtails(inputData)
                  .subscribe(
                    (response) => {
                     // console.log(response);
                      if (response['Status'] == 'Success') {
                        this.isCompleted=true;
                        // this.service.alert("Great! Articulating the application is the first step towards achieving success","success");
                        this.CompletedModule = response['CompletedModule'];
                        this.moduleCompeltedByUser = response['CompletedModule'];
                        this.totalModule=parseInt(response['TotalModule']);

                        this.PerformancePercentage = Math.round(response['PerformancePercentage']) //.toFixed(2);
                        // this.averageScore = Math.round(response['PerformancePercentage'])//.toFixed(2); //This is module avg score
                        this.averageScore=response['AvgScore'];
                        let obj=JSON.parse(localStorage.getItem("loginUserData"));
                        obj.ModuleCompleted=this.moduleCompeltedByUser;
                        obj.UserAvgScore=this.averageScore;
                        localStorage.setItem("loginUserData",JSON.stringify(obj));
                       // console.log(this.averageScore);
                        this.reflectScore();
                        this.btnResult = false;
                        this.isLoading=false;

                        setTimeout(()=>{
                        if(this.isReflect==true){
                            this.setTabActive(4)
                          } else {
                            this.setTabActive(5)
                          }
                        },500)
                        if(sessionStorage.getItem('Guest')!=null){
                          this.isGuestSignUpModal=true;
                        }

                      } else {
                        this.service.alert(response['Message'],"info");
                          this.isLoading=false;

                      }
                    },
                    (error) => {
                     // console.log(error);
                        this.isLoading=false;
                    }
                )

        }
    }

    if(fromQuiz==true){
        if(this.isCompleted ==true ){
         // console.log(this.PerformancePercentage);

                const inputData = {
                  "Islike": this.isLike,
                  "ModuleId": this.moduleId,
                  "UserId": this.loginUserId,
                  "UserRating": 5,
                };

               // console.log(inputData);
                // this.service.updateReflection(inputData)
                //       .subscribe(
                //         (response) => {
                //           if (response['Status'] == 'Success') {
                //             this.service.alert("Updated successfully!" ,"success");
                //             this.btnResult = false;
                //
                //
                //             // this.setTabActive(5);
                //           } else {
                //             this.service.alert(response['Message'],"error");
                //           }
                //         },
                //         (error) => {
                //          // console.log(error);
                //         }
                //       )
        }
        else {
          this.isLoading=true;
         // console.log(this.QuestionDetails);
                  const inputData = {
                    "IsPaid":parseInt(localStorage.getItem("planId"))==-1 ? false : true,
                    "Islike": this.isLike,
                    "ModuleId": this.moduleId,
                    "QuestionDetails": this.QuestionDetails,
                    "UserId": this.loginUserId==-1 ? this.guestUser.guestUserId : this.loginUserId,
                    "UserRating": 5,
                    "IsTestUser": (this.guestUser == null || this.guestUser == undefined) ? false : true
                  };
                 // console.log(inputData);
                  this.service.SaveModuleDtails(inputData)
                  .subscribe(
                    (response) => {
                     // console.log(response);
                      if (response['Status'] == 'Success') {
                          this.isCompleted=true;
                        // this.service.alert("Great! Articulating the application is the first step towards achieving success","success");
                        this.CompletedModule = response['CompletedModule'];
                        this.moduleCompeltedByUser = response['CompletedModule'];
                        this.totalModule=parseInt(response['TotalModule']);

                        this.PerformancePercentage = Math.round(response['PerformancePercentage']) //.toFixed(2);
                        // this.averageScore = Math.round(response['PerformancePercentage'])//.toFixed(2); //This is module avg score
                        this.averageScore=response['AvgScore'];
                        let obj=JSON.parse(localStorage.getItem("loginUserData"));
                        obj.ModuleCompleted=this.moduleCompeltedByUser;
                        obj.UserAvgScore=this.averageScore;
                        localStorage.setItem("loginUserData",JSON.stringify(obj));
                       // console.log(this.averageScore);
                        this.reflectScore();
                        this.btnResult = false;
                        this.isLoading=false;
                        if(this.isReflect==true){
                          this.setTabActive(4);
                        } else {
                          this.setTabActive(5);
                        }
                        // if(sessionStorage.getItem('Guest')!=null){
                        //   this.isGuestSignUpModal=true;
                        // }
                      } else {
                        this.service.alert(response['Message'],"info");
                          this.isLoading=false;

                      }
                    },
                    (error) => {
                     // console.log(error);
                        this.isLoading=false;
                    }
                )

        }
    }



  }


  //Thakur: 24Aug17 for get coaching module
  //Thakur for get all modules
  coachingModule(){
      // this.coachingModuleData=[];
    const inputData = {UserId: this.loginUserId};
   // console.log(inputData);
    this.service.getUserPendingCompletedModule(inputData)
    .subscribe(
      (response: any)=>{
       // console.log(response);
        if(response['Status'] == 'Success'){
          this.coachingModuleData=[];
            this.coachingModuleData = response['UnAssignChapterData'].length > 0 ? response['UnAssignChapterData'] : response['PendingChapterData'];
           // console.log(this.coachingModuleData);
        }else{
          this.service.alert(response['Message'],"info");

        }
      },
      (error: any)=>{
       // console.log(error);
      }
    )

  }

  reload(pvarName, pvarId, pvarIsFree:boolean,shareoptions) {
    if(shareoptions==false){
      // Harkamal Singh:when logged in free user clicks on paid module
      if(this.loginUserId!=-1){
      if(localStorage.getItem("planId")=='-1' && pvarIsFree==false){
        const inputJson={
          "ModuleId":pvarId,
          "UserId":this.loginUserId
        }
       // console.log(inputJson);
        this.service.ClickOnPaidModule(inputJson)
        .subscribe(
          (result:any[])=>{
           // console.log(result);
            if(result['Status']=="Success"){

            }
            else{
              this.service.alert(result['Message'],"error");
            }
          },
          (error:Error)=>{
           // console.log(error);
          }
        )

      }

    }else{
      // when anonymous user clicks on any module
      // this.service.alert("come please sign up First !","error");

    }

    const link = '/module/'+ pvarName +'/'+pvarId;
    this._router.navigate(['/'], {skipLocationChange: true})
    .then(() => { this._router.navigate([link]); });


    }

    else
    return false;
  }

   isTab = 1;
  setTabActive(pvarId) {
    sessionStorage.setItem('isVideo','false');
    //this.ngAfterViewInit();
    $('#hideme').addClass('hideall');
    window.scrollTo(0,0);
    this.toggleSM = false;
    this.updateMetaInfo(this.moduleId);
    if (pvarId == 1) {
      this.isTab = 1;
      this.videoselected = false;
      this.pdfselected = false;
      this.quizselected = false;
      this.reflectselected = false;
      this.resultselected = false;
      this.moreselected = false;
      this.introselected = true;
    }
    if (pvarId == 2) {
      if(this.isPdf == true) {
        pvarId = 7;
      } else {
      this.videoNotReady=true;
      setTimeout(()=>{
        if($('#sun')){
          this.videoNotReady=false;
        }
      },2000)

      this.isMenu = false;
      this.hideit=true;
      $('#hideme').removeClass('hideall');
      if(localStorage.getItem("UserId") != null){
        if(localStorage.getItem("planId") == '-1' && this.isModuleFree == false){
            this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
            this.pricinginfo = this.fb.group({
              'pricing':['', Validators.required],
              'couponCode': ['']
            });
            setTimeout(()=>{
              this.openPricingModal();
            },1000);
            return false;
        }

        this.isTab = 2;
        this.isVideoWatch = true;
        this.videoselected = true;
        this.pdfselected = false;
        this.introselected = false
        this.quizselected = false;
        this.reflectselected = false;
        this.resultselected = false;
        this.moreselected = false;
        let planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"))
        if(planId==-1){
          if(this.isAssigned == false && this.isModuleFree==true && this.isCompleted==false){
            this.assignModule();
            this.isAssigned=true;
          }
        } else {
          if(this.isAssigned == false && this.isCompleted==false){
            this.assignModule();
            this.isAssigned=true;
          }
        }

      }else{
        if(this.isModuleFree == false){
          this.service.alert("Please Login/Sign Up to access this premium module","info");
          this.isUserModal=true;
        }
        else{
        this.service.alert("Please Login/Sign Up to access this free module","info");
        this.isUserModal=true;
        // this.createTestUser();
        // this.isTab = 2;
        // this.isVideoWatch = true;
        // this.videoselected = true;
        // this.pdfselected = false;
        // this.introselected = false
        // this.quizselected = false;
        // this.reflectselected = false;
        // this.resultselected = false;
        // this.moreselected = false;
      }
      }

      setTimeout(()=>{
        var iframe = document.querySelector('iframe');
        var vimeo= new Vimeo(iframe);

        vimeo.on('play',()=>{
        if(sessionStorage.getItem('moduleId')==null){
          if(this.userUpdated==false){
              this.updateUserCount();
          }

        }
          else {
            let moduleSelected:number=parseInt(JSON.parse(sessionStorage.getItem('moduleId')));
            if(moduleSelected!=this.moduleId){
              this.updateUserCount();
            }
          }
        })
      },1000)
      }
    }
    if (pvarId == 3) {

        this.isQuestion = true;
        this.isBadge=false;
        this.quizScore=100;
        let planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"))
      let userId = localStorage.getItem("UserId") == null ? -1 :  parseInt(localStorage.getItem("UserId"));
      if(userId!=-1){
        if(planId==-1){
          if(this.isAssigned == false && this.isModuleFree==true && this.isCompleted==false){
            this.assignModule();
            this.getQusetionData();
            this.isAssigned=true;
          }
          if(this.isAssigned==false && this.isModuleFree==true && this.isCompleted==true){

            this.getQusetionData();
              this.isAssigned=true;

          }

          if(this.isAssigned==true && this.isModuleFree==true && this.isCompleted==false){

            this.getQusetionData();


          }
          if(this.isAssigned == true && this.isCompleted==true && this.isModuleFree==true){

              this.getQusetionData();

          }
        } else {
          if(this.isAssigned == false && this.isCompleted==false){
            this.assignModule();
              this.getQusetionData();
            this.isAssigned=true;
          }
          if(this.isAssigned == false && this.isCompleted==true){

              this.getQusetionData();
            this.isAssigned=true;
          }
          if(this.isAssigned == true && this.isCompleted==false){

              this.getQusetionData();

          }
          if(this.isAssigned == true && this.isCompleted==true){

              this.getQusetionData();

          }
          if(this.isAssigned == false && this.isCompleted==true){

              this.getQusetionData();

          }
        }
      }



      // if(this.isVideoWatch == false){
      //   return false;
      // }
      this.isMenu = false;
      this.hideit=false;
      if(localStorage.getItem("UserId") != null){
        // if(this.btnQuiz == true){
        //   this.service.alert("You are allowed to take the quiz just once.","info");
        //   return false;
        // }
        if(localStorage.getItem("planId") == '-1' && this.isModuleFree == false){
            this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
            this.pricinginfo = this.fb.group({
              'pricing':['', Validators.required],
              'couponCode':['']
            });
            setTimeout(()=>{
              this.openPricingModal();
            },2500);
            return false;
        }
        this.isTab = 3;
        this.quizselected = true;
        this.introselected = false;
        this.pdfselected = false;
        this.videoselected = false;
        this.reflectselected = false;
        this.resultselected = false;
        this.moreselected = false;
      }else{
        if(this.isModuleFree ==false){
          this.service.alert("Please Login/Sign Up to access this premium module","info");
          this.isUserModal=true;
        }
        else{
        this.service.alert("Please Login/Sign Up to access this free module","info");
        this.isUserModal=true;
        // this.getQusetionData();
        // this.createTestUser();
        // this.isTab = 3;
        // this.quizselected = true;
        // this.introselected = false;
        // this.pdfselected = false;
        // this.videoselected = false;
        // this.reflectselected = false;
        // this.resultselected = false;
        // this.moreselected = false;
      }
      }
      this.goTo(0);
    }
    if (pvarId == 4) {

      this.getReflectById();
      this.getGoals();
      // this.getResultData();
      this.hideit=true;
      this.isMenu = false;
      $('#hideme').removeClass('hideall');

      if(localStorage.getItem("UserId") !== null){
        if(localStorage.getItem("planId") == '-1' && this.isModuleFree == false){
            this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
            this.pricinginfo = this.fb.group({
              'pricing':['', Validators.required],
              'couponCode':['']
            });
            setTimeout(()=>{
              this.openPricingModal();
            },1000);
            return false;
        }
        if(this.btnReflect == true)
        return false;
        this.isTab = 4;
        this.reflectselected = true;
        this.quizselected = false;
        this.introselected = false;
        this.pdfselected = false;
        this.videoselected = false;
        this.resultselected = false;
        this.moreselected = false;

      }else{
        // this.service.alert("Please Login/Sign Up to continue","info");
        // this.isUserModal=true;
        if(this.isModuleFree == false){
        this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
          return false;
        } else {
          this.service.alert("Please Login/Sign Up to access this free module","info");
          this.isUserModal=true;
          // this.createTestUser();
          // this.isTab = 4;
          // this.reflectselected = true;
          // this.quizselected = false;
          // this.introselected = false;
          // this.pdfselected = false;
          // this.videoselected = false;
          // this.resultselected = false;
          // this.moreselected = false;
        }

      }
    }
    if (pvarId == 5) {
  let planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"))
      if(this.isCompleted==false){
        if(this.loginUserId!=-1){
          if(planId==-1  && this.isModuleFree == false){

            this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
            this.pricinginfo = this.fb.group({
              'pricing':['', Validators.required],
              'couponCode':['']
            });
            setTimeout(()=>{
              this.openPricingModal();
            },1000);
            return false;
          }

          if(planId!=-1){

            return false;
          }
        }

        this.ratingsModal=false;
      }


      if(this.loginUserId==-1){
        if(this.guestUser!=null || this.guestUser!=undefined){
          // console.log(this.isCompleted);
          this.btnResult=this.isCompleted==true ? false : true
          if(this.btnResult){
            return false;
          }
        }


        // this.service.alert("Please Login/Signup to continue","error");
        // this.isUserModal=true;
        //
        // return false;
        if(this.isCompleted==false && sessionStorage.getItem('Guest')==null){
          this.isUserModal=true;
          return false
        } else {
          // this.createTestUser();
          this.isTab = 5;
          this.resultselected = true;
          this.reflectselected = false;
          this.quizselected = false;
          this.introselected = false;
          this.pdfselected = false;
          this.videoselected = false;
          this.moreselected = false;
        }

      }
        if(planId==-1  && this.isModuleFree == false){

          this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
          return false;
        }
      this.committedModal=false;
        this.isLoading=true;
        if(this.isCompleted==true){
            this.ratingsModal=true;
        }


      setTimeout(()=>{
        $('.confetti-button').addClass('animate')
        setTimeout(()=>{
          $('.confetti-button').removeClass('animate')
        },800);
      },1000)
        this.badgeUnlocked=$('badge-container').length>0 ? true : false;
      if(this.isCompleted==true){

        this.getResultData();
      }

        this.isMenu = false;
        this.hideit=false;
        if(this.btnResult == true){
          this.isLoading=false;
          return false;
        }

        if(localStorage.getItem("UserId") !== null){
          if(localStorage.getItem("planId") == '-1' && this.isModuleFree == false){
              this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
              this.pricinginfo = this.fb.group({
                'pricing':['', Validators.required],
                'couponCode':['']
              });
              setTimeout(()=>{
                this.openPricingModal();
              },1000);
              return false;
          }
          this.isTab = 5;
          this.resultselected = true;
          this.reflectselected = false;
          this.quizselected = false;
          this.introselected = false;
          this.pdfselected = false;
          this.videoselected = false;
          this.moreselected = false;
        }else{
          // this.service.alert("Please Login/Sign Up to continue","info");
          // setTimeout(()=>{
          //   window.location.href = '/login';
          // },1000)
        }
          this.isLoading=false;
    }
    if (pvarId == 6) {
      this.isMenu = false;
      this.hideit=false;
      if(localStorage.getItem("UserId") !== null){
        if(localStorage.getItem("planId") == '-1' && this.isModuleFree == false){
            this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
            this.pricinginfo = this.fb.group({
              'pricing':['', Validators.required],
              'couponCode':[]
            });
            setTimeout(()=>{
              this.openPricingModal();
            },1000);
            return false;
        }
        this.isTab = 6;
        this.moreselected = true;
        this.resultselected = false;
        this.reflectselected = false;
        this.quizselected = false;
        this.introselected = false;
        this.pdfselected = false;
        this.videoselected = false;
      }else{
        this.isTab = 6;
        this.moreselected = true;
        this.resultselected = false;
        this.reflectselected = false;
        this.quizselected = false;
        this.introselected = false;
        this.pdfselected = false;
        this.videoselected = false;
        // this.service.alert("Please Login/Sign Up to continue","info");
        // setTimeout(()=>{
        //   window.location.href = this.happcoachHostUrl+'/login';
        // },1000)
      }
    }
    if (pvarId == 7) {       
      this.isMenu = false;
      this.hideit=true;
      $('#hideme').removeClass('hideall');
      if(localStorage.getItem("UserId") != null){             
        if(localStorage.getItem("planId") == '-1' && this.isModuleFree == false){
            this.service.alert("Sorry! This is not a free lunch. You might want to upgrade to a paid plan","info");
            this.pricinginfo = this.fb.group({
              'pricing':['', Validators.required],
              'couponCode': ['']
            });
            setTimeout(()=>{
              this.openPricingModal();
            },1000);
            return false;
        }

        this.isTab = 7;
        this.isPdfWatch = true;
        this.pdfselected = true;
        this.isVideoWatch = false;
        this.videoselected = false;         
        this.introselected = false
        this.quizselected = false;
        this.reflectselected = false;
        this.resultselected = false;
        this.moreselected = false;
        let planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"))
        if(planId==-1){
          if(this.isAssigned == false && this.isModuleFree==true && this.isCompleted==false){
            this.assignModule();
            this.isAssigned=true;
          }
        } else {
          if(this.isAssigned == false && this.isCompleted==false){
            this.assignModule();
            this.isAssigned=true;
          }
        }

      }else{             
        if(this.isModuleFree == false){
          this.service.alert("Please Login/Sign Up to access this premium module","info");
          this.isUserModal=true;
        }
        else{
        this.service.alert("Please Login/Sign Up to access this free module","info");
        this.isUserModal=true;
        // this.createTestUser();
        // this.isTab = 7;
        // this.isPdfWatch = true;
        // this.pdfselected = true;
        // this.isVideoWatch = false;
        // this.videoselected = false;          
        // this.introselected = false
        // this.quizselected = false;
        // this.reflectselected = false;
        // this.resultselected = false;
        // this.moreselected = false;
      }
      }
  }
  }

  getYouTubId(varUrl) {
      var url = varUrl; //"http://www.vimeo.com/7058755";
      var regExp = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
      var match = url.match(regExp);
      if (match) {
       // console.log("id: " + match[1]);
        return this.sanitizer.bypassSecurityTrustResourceUrl("https://player.vimeo.com/video/" + match[1])
      }
      else {
       // console.log("not a vimeo url");
        //return this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/233612191');

        var url = varUrl;//'https://youtu.be/LNumWHvVVEs';
       // console.log(url);
        var videoid = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
        if (videoid != null) {
         // console.log("Base Url---  "+this.baseUrl);
         // console.log("video id = ", videoid[1]);
          return this.sanitizer.bypassSecurityTrustResourceUrl(this.baseUrl + "/embed/" + videoid[1])
          //return 'https://www.youtube.com/embed/' + videoid[1];
        } else {
         // console.log("The youtube url is not valid.");
          return this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/233612191');
        }
      }
  }


    getYouTubId_old(varUrl) {
      if (varUrl != undefined) {
        var url = varUrl;//'https://youtu.be/LNumWHvVVEs';
        var videoid = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
        if (videoid != null) {
         // console.log("video id = ", videoid[1]);
          return this.sanitizer.bypassSecurityTrustResourceUrl(this.baseUrl + "/embed/" + videoid[1])
          //return 'https://www.youtube.com/embed/' + videoid[1];
        } else {
          //// console.log("The youtube url is not valid.");
        }
      }
    }


  //Method for assign module to login user
  assignModule(guest?:Guest){
    let inputData = {
        "ModuleId":this.moduleId,
        "UserId": this.loginUserId
    };

    if(this.loginUserId==-1){
      if(guest==undefined){
          return false;
      } else {
         inputData = {
            "ModuleId":this.moduleId,
    	      "UserId": guest.guestUserId
        }
      }

    }
    else{

       inputData = {
          "ModuleId":this.moduleId,
  	      "UserId": this.loginUserId
      }
    }
        // console.log(inputData)

      this.service.assignModuleToUser(inputData)
      .subscribe(
        (response)=>{
          if(response['Status'] == "Success"){
            sessionStorage.setItem("isPendingModule", '1');
            this.isAssigned=true;
          }else{
            this.service.alert(response['Message'],"error");

          }
        },
        (error)=>{

        }
      )

  }

  //moduleLike
  selectedClass: any = 'heart';
  moduleLikeUnlike(){
    if(this.loginUserId!=-1){
    // console.log("click for bookmark")
     this.isLike = this.isLike == true ? false : true;
     this.selectedClass = this.isLike == true ? 'heart heartchecked': 'heart';
     const inputJson={
	      "ModuleId":this. moduleId,
	       "Status":this.isLike,
	        "UserId":this.loginUserId
        }
       // console.log(inputJson);
        this.service.AddBookmark(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              if(inputJson.Status==true){
                this.service.alert("Bookmark added successfully","success");
              } else {
                this.service.alert("Bookmark removed successfully","success");

              }
              this.getUserModule();
            } else {
              this.service.alert(result['Message'],'error');

            }
          },
          (error)=>{
           // console.log(error);
          }
        )
      }
      else{
      this.service.alert("Please Login/Sign Up to use the bookmark feature","error");
      this.isUserModal = true;
    }
  }

  nextModule(pvarNext){

    const cModule =pvarNext
   // console.log(cModule);
   // console.log(cModule.length);
    if(cModule.length > 0){
      if(cModule[0]['IsFree'] == true){
        const link = '/module/' + cModule[0]['ChapterName'] + '/' + cModule[0]['ChapterId'];
        this._router.navigate(['/'], {skipLocationChange: true})
        .then(() => { this._router.navigate([link]); });
      }else{
        const link = '/module/' + cModule[0]['ChapterName'] + '/' + cModule[0]['ChapterId'];
        this._router.navigate(['/'], {skipLocationChange: true})
        .then(() => { this._router.navigate([link]); });

        // if(localStorage.getItem("planId") == '-1' && cModule[0]['IsFree'] == false){
        //   this.service.alert("Please choose plan !","info");
        //   this.pricinginfo=this.fb.group({
        //     'pricing':['', Validators.required],
        //     'couponCode': []
        //   });
        //   setTimeout(()=>{
        //     this.isPricingModal = true;
        //   },2500);
        // }else{
        //   const link = '/module/' + cModule[0]['ChapterName'] + '/' + cModule[0]['ChapterId'];
        //   this._router.navigate(['/'], {skipLocationChange: true})
        //   .then(() => { this._router.navigate([link]); });
        // }
      }
    }
  }


  blink_state = 0;
  private btnText : string = "Ready";
  readySteadyGo = ""
  blinkTextForButton(){
      if(this.blink_state==0){
          this.btnText = "Ready";
          this.blink_state=1;
          this.readySteadyGo = 'ready';
      }
      else if(this.blink_state==1){
          this.btnText = "Steady";
          this.readySteadyGo = 'steady';
          this.blink_state=2;
      }
      else{
          this.btnText = "Go";
          this.readySteadyGo = 'go'
          this.blink_state=5;
      }
  }

  addEvent(name, date, introduction){
    const abc = 'https://www.google.com/calendar/render?action=TEMPLATE&text='+name+'&dates='+date+'/'+date+'&details='+introduction+'&location=Happcoach&sf=true&output=xml';
    window.location(abc);
  }

  showtip() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  tab() {
    $(".btn-group a").click(function() {
      $(this).addClass('active');
      $(".btn-group a").not(this).removeClass('active');
    });
  }

  ngAfterViewInit(){

    $('.cd-header').css('background-color','rgb(147, 18, 70)');
      $(window).scrollTop(0);
    // System.import('../script.js')
    // .then(xJS => {
    //
    // });
    $("[title='share']").hover(function(){
      // $(this).toggleClass('animated bounce');
    }).click(function(){

    });

    if(this.hideit==false){
      $('#hideme').addClass('hideall');
    }
    else
    $('#hideme').removeClass('hideall');

    $(window).resize(()=>{
      if(this.loginUserId != -1){
        this.activeSlider();
      }
      this.activeTrendingSlider();
    });
    $('#smalltabs').click(function(){

      $('#video .scrollable').scrollTop($('#video .scrollable').height()/2-50);
    })



  }
  formatDt(pvarDate){
    let b:any="";
    let hours:string="";
    let mins:string="";
    //// console.log("pvarDate----------------- "+ pvarDate)
    if(pvarDate!=null){
      var datePipe = new DatePipe("en-US");
      var a=pvarDate.substring(0,pvarDate.length-2);

      a = datePipe.transform(a, 'yyyyMMdd');
      b=new Date().toISOString();
      var mydate=b.split(':');

      hours=mydate[0].substring(mydate[0].length-2);
      mins=mydate[1]+"00";
      b=a+"T"+hours+mins+"Z";
      return b;
    }else{
      var dt = this.startDate;
      var datePipe = new DatePipe("en-US");
      var a:any = dt.substring(0,dt.length-2);

      a = datePipe.transform(a, 'yyyyMMdd');
      return a;

    }
  }

    happcoachLogin(pvarChoice){

      if(pvarChoice==1){
        setTimeout(()=>{
          sessionStorage.setItem("IsStratGistLogin","true");
          this._router.navigate(['/login']);
        },1000)
      }
      if(pvarChoice==0){
        setTimeout(()=>{
          sessionStorage.setItem("IsStratGistLogin","false");
          this._router.navigate(['/login']);
        },1000)
      }
    }

    activeTrendingSlider(){
        var isFavCenter = false;
        if(this.tremdingModuleData.length > 4){
          isFavCenter = true;
        }
        if(this.tremdingModuleData.length <= 4){
          this.paddingCoaching=true;
        }

        var width=$(window).width();
        if(width<=768 && this.tremdingModuleData.length > 3){
          this.seeMoreTrendingSm=true;
        }

        if(width>768 && this.tremdingModuleData.length > 5){
          this.seeMoreTrendingLg=true;
        }


        var $carouse5 = $('.trending');
        var settings = {
          dots: false,
          arrows: true,
          slide: '.slick-slideshow__slide',
          slidesToShow: 4,
          centerMode: true,
          initialSlide: 0,
          centerPadding: '20px',
          infinite:false,
          nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
          prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
          responsive: [
              {
                breakpoint: 900,
                settings: {
                arrows: true,
                nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
                prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 2,
                initialSlide: 0,
                }
            },
            {
              breakpoint: 680,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 2,
              initialSlide: 0,
              }
          },
              {
                breakpoint: 500,
                settings: {
                arrows: true,
                nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
                prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
                centerMode: true,
                centerPadding: '25px',
                slidesToShow: 1,
                initialSlide: 0
                }
              },

              {
                breakpoint: 1100,
                settings: {
                arrows: true,
                nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
                prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 3
                }
              },

              {
                breakpoint: 1500,
                settings: {
                arrows: true,
                nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
                prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 4
                }

              },

              {
                breakpoint: 1650,
                settings: {
                arrows: true,
                nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
                prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 5
                }

              },

              {
                breakpoint: 2200,
                settings: {
                arrows: true,
                nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
                prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 6
                }
              },
              {
                breakpoint: 2600,
                settings: {
                arrows: true,
                nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="trending-right5"></i>',
                prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="trending-left5"></i>',
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 8
                }
              },
            ]
        };

        if($(window).width()>768){
        if(!$carouse5.hasClass('slick-initialized')){
          $carouse5.slick(settings);
        }
      }
        if($(window).width()<=768){
            if(this.tremdingModuleData.length > 1){
              if(!$carouse5.hasClass('slick-initialized')){
                $carouse5.slick(settings);
            }
          }
        }
        this.setSlideVisibility($carouse5);
        $('#trending-left5').css('display', 'none')
        $carouse5.on('afterChange', function(slide, index) {
          // console.log(index.currentSlide);
           if(index.options.slidesToShow==1){
             var count = index.slideCount - index.options.slidesToShow;
             if(index.currentSlide === 1) {
                 $('#trending-left5').css('display', 'block')
             }
             if(index.currentSlide === 0) {
                 $('#trending-left5').css('display', 'none')
             }
             if(index.currentSlide === count) {
                 $('#trending-right5').css('display', 'none')
             }

             else {
                $('#trending-right5').css('display', 'block')
                if(index.currentSlide > 1){
                  //$(".caromid").css('padding-left',"36px");
                }
                if(index.currentSlide == 1){
                //  $(".caromid").css('padding-left',"15px");
                }
             }
           } else {
             var count = index.slideCount - index.options.slidesToShow;
             if(index.currentSlide === 1) {
                 $('#trending-left5').css('display', 'block')
             }
             if(index.currentSlide === 0) {
                 $('#trending-left5').css('display', 'none')
             }
             if(index.currentSlide === count) {
                 $('#trending-right5').css('display', 'none')
             }
             else {
                $('#trending-right5').css('display', 'block')
                if(index.currentSlide > 1){
                  //$(".caromid").css('padding-left',"36px");
                }
                if(index.currentSlide == 1){
                //  $(".caromid").css('padding-left',"15px");
                }
             }
           }
        });

        let widthScreen=$(window).width();
        setTimeout(()=>{
          if(widthScreen<=1500 && widthScreen>=1024){
            if(this.tremdingModuleData.length<5){
              this.noTrendingSlider=true;
            }
          }

          if(widthScreen<=1650 && widthScreen>=1501){
            if(this.tremdingModuleData.length<6){
              this.noTrendingSlider=true;
            }
          }

          if(widthScreen<=2200 && widthScreen>=1651){
            if(this.tremdingModuleData.length<7){
              this.noTrendingSlider=true;
            }
          }
          if(widthScreen<=2600 && widthScreen>=2201){
            if(this.tremdingModuleData.length<9){
              this.noTrendingSlider=true;
            }
          }
        },250)
    }

    activeSlider(){
      var isFavCenter = false;
      if(this.coachingModuleData.length > 4){
        isFavCenter = true;
      }
      if(this.coachingModuleData.length <= 4){
        this.paddingCoaching=true;
      }

      var width=$(window).width();
      if(width<=768 && this.coachingModuleData.length > 3){
        this.seeMoreSm=true;
      }

      if(width>768 && this.coachingModuleData.length > 5){
        this.seeMoreLg=true;
      }


      var $carouse5 = $('.caromid');
      var settings = {
        dots: false,
        arrows: true,
        slide: '.slick-slideshow__slide',
        slidesToShow: 4,
        centerMode: true,
        initialSlide: 0,
        centerPadding: '20px',
        infinite:false,
        nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
        prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
        responsive: [
            {
              breakpoint: 900,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 2,
              initialSlide: 0,
              }
          },
          {
            breakpoint: 680,
            settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 2,
            initialSlide: 0,
            }
        },
            {
              breakpoint: 500,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
              centerMode: true,
              centerPadding: '25px',
              slidesToShow: 1,
              initialSlide: 0
              }
            },

            {
              breakpoint: 1100,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 3
              }
            },

            {
              breakpoint: 1500,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 4
              }

            },

            {
              breakpoint: 1650,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 5
              }

            },

            {
              breakpoint: 2200,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 6
              }
            },



            {
              breakpoint: 2600,
              settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right5"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left5"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 8
              }
            },

          ]
      };

      if($(window).width()>768){
      if(!$carouse5.hasClass('slick-initialized')){

      $carouse5.slick(settings);
    }
      // if(this.coachingModuleData.length <= 4){
      //
      //   if($carouse5.hasClass('slick-initialized')) {
      //   $carouse5.slick('unslick');
      // }
      // }
    }
      if($(window).width()<=768){
      if(this.coachingModuleData.length > 1){
        if(!$carouse5.hasClass('slick-initialized')){
          $carouse5.slick(settings);
      }
    }
    }



      //$carouse5.slick('slickGoTo', 1);
      this.setSlideVisibility($carouse5);

      // $carouse5.on('afterChange', function() {
      //   this.setSlideVisibility($carouse5);
      // });



      $('#free-left5').css('display', 'none')
      $carouse5.on('afterChange', function(slide, index) {
        // console.log(index.currentSlide);
         if(index.options.slidesToShow==1){
           var count = index.slideCount - index.options.slidesToShow;
           if(index.currentSlide === 1) {
               $('#free-left5').css('display', 'block')
           }
           if(index.currentSlide === 0) {
               $('#free-left5').css('display', 'none')
           }
           if(index.currentSlide === count) {
               $('#free-right5').css('display', 'none')
           }

           else {
              $('#free-right5').css('display', 'block')
              if(index.currentSlide > 1){
                //$(".caromid").css('padding-left',"36px");
              }
              if(index.currentSlide == 1){
              //  $(".caromid").css('padding-left',"15px");
              }
           }
         } else {

           var count = index.slideCount - index.options.slidesToShow;
           if(index.currentSlide === 1) {
               $('#free-left5').css('display', 'block')
           }
           if(index.currentSlide === 0) {
               $('#free-left5').css('display', 'none')
           }
           if(index.currentSlide === count) {
               $('#free-right5').css('display', 'none')
           }

           else {
              $('#free-right5').css('display', 'block')
              if(index.currentSlide > 1){
                //$(".caromid").css('padding-left',"36px");
              }
              if(index.currentSlide == 1){
              //  $(".caromid").css('padding-left',"15px");
              }
           }
         }


         //setSlideVisibility();
      });

      let widthScreen=$(window).width();
      setTimeout(()=>{
        if(widthScreen<=1500 && widthScreen>=1024){


          if(this.coachingModuleData.length<5){
            this.noSlider=true;
          }



        }

        if(widthScreen<=1650 && widthScreen>=1501){


          if(this.coachingModuleData.length<6){
            this.noSlider=true;
          }



        }

        if(widthScreen<=2200 && widthScreen>=1651){


          if(this.coachingModuleData.length<7){
            this.noSlider=true;
          }



        }

        if(widthScreen<=2600 && widthScreen>=2201){


          if(this.coachingModuleData.length<9){
            this.noSlider=true;
          }

        }
      },250)

    }

    selectedID: any = 0;
    seledmoduleId = 0;
    shareId:number=0;
    displayShareOptions(pvarIndex, pvarObj){
     // console.log(pvarObj);
     // console.log("thumbshare before "+this.thumbShare);
      this.shareId=pvarObj['ChapterId'];
      this.meta.updateTag({
        content: 'http://happcoach.com/PilotServices/Module/'+this.shareId+'.html'
        },
       "property='og:url'"
      );
      if(this.seledmoduleId == 0){
        this.seledmoduleId = pvarObj['ChapterId'];
        this.selectedID = pvarObj['ChapterId'];

      }
      else if(this.seledmoduleId != 0){
        if(this.seledmoduleId == pvarObj['ChapterId']){
           // this.seledmoduleId = 0;
           // this.selectedID = 0;

         }else{
           this.seledmoduleId = pvarObj['ChapterId'];
           this.selectedID = pvarObj['ChapterId'];
         }
      }
      //this.myarr[pvarIndex]['IsShare']=!this.myarr[pvarIndex]['IsShare'];
      this.thumbShare=true;
     // console.log("thumbshare after "+this.thumbShare);
    }

    applyVideoCss(){
      $('.player .vp-player-layout').css(
      {'position': 'absolute',
      'top': '0!important',
      'left': '0!important',
      'bottom': '15px!important',
      'right': '0!important',
      'overflow': 'hidden'})
    }

    likeSelectedModule(index,module){
      const inputJson={
    	   "ModuleId":index,
    	    "Status":true,
    	    "UserId":this.loginUserId
      }

     // console.log(index);
     // console.log(module);

      // let filteredarray:any[]=[];
      // filteredarray=this.coachingModuleData.filter(data=>{
      //  // console.log(data);
      // data['ModuleChapterId']==index
      // }
      // );
      //// console.log(filteredarray);
      if(this.loginUserId!=-1){
        if(module['IsLike']=="False"){
          module['IsLike']="True";
          inputJson.Status=true;
         // console.log(module['IsLike']);
        }
      else if(module['IsLike']=="True"){
          module['IsLike']="False";
          inputJson.Status=false;

         // console.log(module['IsLike']);
        }
       // console.log(inputJson);
        this.service.AddBookmark(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              if(inputJson.Status==false){
              this.service.alert("Bookmark removed successfully","success");
              }
              if(inputJson.Status==true){
              this.service.alert("Bookmark added successfully","success");
              }

            } else {
              this.service.alert(result['Message'],"error");
            }
          },
          (error)=>{
           // console.log(error);
          }
        )

      }
      if (this.loginUserId==-1){
        this.service.alert("Please Login/Sign Up to use the bookmark feature" ,"info");
        setTimeout(()=>{
          this.isUserModal=true;
        },2000);


      }

      }

    showMenu(){
      this.isMenu=!this.isMenu;
      this.toggleSM=false;
    }

    //Thakur: 6Nov2017 for Apply coupon code


    couponAmount: any = 0;
    couponId: any = -1;
    netPayableAmount: any = 0;
    discountAmount : any = 0;

    openPricingModal(){

      this.service.GetPlan()
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
              this.planData=result['PlanData'];
          } else {

          }
        },
        (error)=>{

        }
      )

      this.couponAmount= 0;
      this.couponId = -1;
      this.netPayableAmount = 0;
      this.discountAmount = 0;
      this.responseMessage= '';
      this.pricinginfo = this.fb.group({
        'pricing':['', Validators.required],
        'couponCode': ['']
      });
      $('#hideme').removeClass('hideall');
      // this.isPricingModal=true;
    }

    closePricingModal(){
      $('#hideme').addClass('hideall');
      this.isPricingModal=false;
    }

    applyCode(pricinginfo){
      const inputData = {
        "CouponCode": pricinginfo.couponCode
      }
      this.service.applyCoupon(inputData)
      .subscribe(
        (res: any[])=>{
          if(res['Status'] == "Success"){
            this.responseMessage="Coupon Applied";
           // console.log(res);
            this.couponId = res['CouponId'];
            this.couponAmount = parseFloat(res['Amount']);

              var c: any = (pricinginfo.pricing * this.couponAmount) / 100;
              this.discountAmount = parseInt(c);
              var d: any = pricinginfo.pricing - this.discountAmount
              this.netPayableAmount = parseInt(d);


          }else{
            this.responseMessage=res['Message'];


              var planId = this.pricinginfo.controls['pricing'].value;

              this.couponAmount = 0
              this.couponId = -1;

              this.discountAmount = 0;

          }
        },
        (error)=>{
            this.service.alert(error,"error");
        }
      )
    }

    //If couponCode empty
    couponCode = "";
    // searchEmpety(){
    //   var planId = this.pricinginfo.controls['pricing'].value;
    //   if(this.couponCode.length == 1){
    //     this.couponAmount = 0
    //     this.couponId = 0;
    //     this.netPayableAmount = planId == 1 ? 3999 : 8999;
    //     this.discountAmount = 0;
    //   }
    // }

    //On plan select
    slectedPlanId: any;
    handlePlanChange(pvarId, pvarPlanId){
     // console.log(pvarId);
      this.slectedPlanId = pvarPlanId;
      if(pvarId == -1){
        this.couponAmount = 0
        this.couponId = -1;
        this.netPayableAmount = 0;
        this.discountAmount = 0;
        this.responseMessage="";
        return false;
      }
      else {
        var c: any = (parseInt(pvarId) * this.couponAmount) / 100;
        this.discountAmount = parseInt(c);
        var d: any = parseInt(pvarId) - this.discountAmount
        this.netPayableAmount = parseInt(d);
      }
    }

    //Submit paln
    addPricing(priceform){
      const _successUrl = "https://stratgist.com/workSmarts/thanks";
      const _failureUrl= "https://stratgist.com/workSmarts";
      // const _successUrl = "http://52.66.183.31/pbweb/";
      // const _failureUrl= "https://52.66.183.31/pbweb/";
      //const _successUrl = "http://localhost:3000/"+ this._router.url;
      //const _failureUrl= "http://localhost:3000/payment-status/failure";
      if(priceform.pricing != '' && priceform.pricing != -1){
        const inputData = {
        "Amount":this.netPayableAmount,
      	"CouponId":this.couponId,
      	"FailureUrl":_failureUrl,
      	"PlanId":parseInt(this.slectedPlanId),
      	"SuccessUrl":_successUrl,
      	"UserId":this.loginUserId
        };
       // console.log(inputData);
        this.service.PaymentForModule(inputData)
        .subscribe(
          (response)=>{
           // console.log(response);
            if(response['Status'] =="Success"){
               this.isPricingModal = false;
               this.closePricingModal();
               location.href = "https://stratgist.com/MasterProjectBytePayment/?Paymentid=" + response['Id'];
               // fbq('track', 'AddPaymentInfo');
               // location.href = "http://52.66.183.31/MasterProjectBytePayment/?Paymentid=" + response['Id'];
            }else{
              this.service.alert(response['Message'],"error");
            }
          },
          (error)=>{
            this.service.alert(error, 'error');
          }
        )
      }else{
        this.pricinginfo = this.fb.group({
          'pricing':['', Validators.required],
          'couponCode': ['']
        });
        this.isPricingModal=false;
        return false;
      }
    }

    //Create new reflect
   // createReflections(): FormGroup {
   //   return this.fb.group({
   //     Reflect: ['',Validators.required]
   //   });
   // }
   //
   // addMoreReflection(){
   //   var items = this.rForm.get('ReflectData') as FormArray;
   //  // console.log(items.length);
   //   items.push(this.createReflections());
   // }
   //End thakur 6Nov2017



   sanitize(){
     let url:string="whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.shareId+".html";
     // let url:string="whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.shareId+".html";

     this.myurl=url;
      let s:SafeUrl=this.sanitizer.bypassSecurityTrustUrl(this.myurl);
      return s;
   }

    updateMetaInfo(pvarId){
      this.shareId=pvarId;
        this.meta.updateTag({
          content: 'https://stratgist.com/Module/workSmarts-'+this.shareId+'.html'
            // content: 'http://52.66.183.31/MasterProjectByte/Module/'+this.shareId+'.html'
          },
          "property='og:url'"
        );
    }

    shareWhatsApp(){
      window.location.href = "whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.shareId+".html";
      // window.location.href = "whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.shareId+".html";

    }

     setSlideVisibility(carousel) {
      //Find the visible slides i.e. where aria-hidden="false"
      var visibleSlides = carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
      //Make sure all of the visible slides have an opacity of 1
      $(visibleSlides).each(function() {
        $(this).css('opacity', 1);
      });

      //Set the opacity of the first and last partial slides.
      //$(visibleSlides).first().prev().css('opacity', 0);
    }

    getNextChapter(){

          // this.coachingModuleData=[];
        const inputData = {UserId: this.loginUserId};
       // console.log(inputData);
        this.service.getUserPendingCompletedModule(inputData)
        .subscribe(
          (response: any)=>{
           // console.log(response);
            if(response['Status'] == 'Success'){
              this.coachingModuleData=[];
                this.coachingModuleData = response['UnAssignChapterData'].length > 0 ? response['UnAssignChapterData'] : response['PendingChapterData'];
                this.nextModule(this.coachingModuleData);
            }else{
              this.service.alert(response['Message'],"info");

            }
          },
          (error: any)=>{
           // console.log(error);
          }
        )

      }

      formatCtDt(){
        var d=this.currentDate;
        if(d != null){
        var stDate = new Date(d);
        var datePipe = new DatePipe("en-US");
       // console.log(datePipe.transform(stDate,'MMMM dd yyyy'));
        return (datePipe.transform(stDate,'MMMM dd yyyy')+" 12:00AM");
        }
      }


      getImage(image){
        return image;
      }

      getUserModule(){
          const inputData = {UserId: this.loginUserId};
          this.service.getUserPendingCompletedModule(inputData)
          .subscribe(
            (response: any)=>{
             // console.log(response);
              if(response['Status'] == 'Success'){

                  sessionStorage.setItem("UserModule", JSON.stringify(response));
              }else{
                this.service.alert(response['Message'], "error");
              }
            },
            (error: any)=>{
             // console.log(error);
            }
          )
      }

      getQusetionData(){
        const inputJson={
          "ModuleId":this.moduleId
        }
       // console.log("Module Id is "+this.moduleId);
        this.service.GetQusetionData(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              this.quiz=[];
              this.quiz = result['GetQuesn'];
              this.pager.count = result['GetQuesn'].length;
            } else {
              this.service.alert(result['Message'],"error");
            }
          },
          (error)=>{
           // console.log(error);
          }
        )
      }

      getReflectById(){
          // this.rForm.controls['ReflectData'] = this.fb.array([]);
        const inputJson={

        	"ModuleId":this.moduleId,
        	"UserId":this.loginUserId
        }
       // console.log(inputJson);
        this.service.GetReflectById(inputJson)
        .subscribe(
          (result:any[])=>{
           // console.log(result);
            if(result['Status']=="Success"){
              if(result['ReflectionDetails'].length > 0){
                this.btnReflect = false;
                this.btnResult = false;

                // this.btnQuiz = true;
               // console.log(  result['ReflectionDetails']);
               // Iterate through the line items and patch them
               this.selectedGoals=result['ReflectionDetails'];
              // console.log(this.selectedGoals);
               this.actionPlan=true;
            }else{
              this.areaFeedback=true;
            }


            // if(result['UserModuleDetails'].length > 0){
            //   const userDetail = result['UserModuleDetails'][0];
            //   this.assignRating = userDetail['UserRating'] > 0 ? userDetail['UserRating'] : 5;
            //   this.isLike = userDetail['Islike'];
            //  // console.log(userDetail['Islike']);
            //
            //   this.PerformancePercentage = Math.round(userDetail['Score']);
            // }
            this.reflectScore();
            }else {
              this.service.alert(result['Messsage'],"error");
            }
          },
          (error)=>{
           // console.log(error);
          }
        )

      }

      getResultData(){
        this.guestUser=sessionStorage.getItem('Guest')!=null ? JSON.parse(sessionStorage.getItem('Guest')) : null
        const inputJson={

        	"ModuleId":this.moduleId,
        	"UserId":  this.guestUser!=null ? this.guestUser.guestUserId : this.loginUserId
        }
       // console.log(inputJson);
        this.service.GetResultData(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              let obj=JSON.parse(localStorage.getItem("loginUserData"));
              this.totalModule=result['UserModuleDetails'].length> 0 ? result['UserModuleDetails'][0]['TotalModule'] : 0;
              this.PerformancePercentage = result['UserModuleDetails'].length> 0 ?Math.round( result['UserModuleDetails'][0]['Score'] ):0;
              this.averageScore = result['UserModuleDetails'].length> 0 ?Math.round( result['UserModuleDetails'][0]['UserAvgScore'] ):0;
              this.moduleRating=result["UserModuleDetails"].length > 0 ? result["UserModuleDetails"][0]['UserRating'] : this.moduleRating;
              this.rForm.patchValue({
                'UserRating':  this.moduleRating
              })
              // if(result['UserModuleDetails'][0]['Reflect1']=="" && result['UserModuleDetails'][0]['Reflect2']=="" && result['UserModuleDetails'][0]['Reflect1']==""){
              //   this.rForm.controls['ReflectData'] = this.fb.array([this.createReflections()]);
              // }
              // else {
              //   result['UserModuleDetails'].forEach((lineItem, index) => {
              //   // Create the item obj
              //   let lineItemObj = {
              //     Reflect:lineItem.Reflextion
              //   }
              //  // console.log(lineItemObj);
              //   const control = <FormArray>this.rForm.controls['ReflectData'];
              //   control.push(this.createReflections());
              //   control.at(index).patchValue(lineItemObj);
              // });
              // }



            } else
            {
              this.service.alert(result['Message'],"error");
            }
          },
          (error)=>{
           // console.log(error);
          }
        )
      }

      getChapterData(){
        const inputJson={

        	"ModuleId":this.moduleId,
        	"UserId":this.loginUserId
        }
       // console.log(inputJson);
        // this.service.GetChapterData(inputJson)
        // .subscribe(
        //   (result:any[])=>{
        //
        //   },
        //   (error)=>{
        //
        //   }
        // )
      }

      showShareOptions(pvarId,pvarType){
       // console.log(pvarId);
        if(this.shareModuleId==pvarId){
            this.isShareMenu=!this.isShareMenu;
        }
        else {
            this.isShareMenu=true;
        }
        this.shareModuleId=pvarId;
        this.type=pvarType;

        this.updateMeta();
      }

      hideShareOptions(pvarId){
        if(this.shareModuleId==pvarId)
        this.isShareMenu=false;
      }

      goToModule(pvarId,pvarName,isLink,pvarIsFree){
        if(isLink==true){
          if(this.loginUserId!=-1){
          if(localStorage.getItem("planId")=='-1' && pvarIsFree==false){
            const inputJson={
              "ModuleId":pvarId,
              "UserId":this.loginUserId
            }
           // console.log(inputJson);
            this.service.ClickOnPaidModule(inputJson)
            .subscribe(
              (result:any[])=>{
               // console.log(result);
                if(result['Status']=="Success"){

                }
                else{
                  this.service.alert(result['Message'],"error");
                }
              },
              (error:Error)=>{
               // console.log(error);
              }
            )

          }

        }
          pvarName=pvarName.split(' ').join('-');
          const link = '/module/'+ pvarName +'/'+pvarId;
          this._router.navigate(['/'], {skipLocationChange: true})
          .then(() => { this._router.navigate([link]); });


        } else {
          return false;
        }
      }

      getDashBoardModuleV2(){

        const inputJson={
        	"Type":"Recommended",
        	"UserId":this.loginUserId
        }
       // console.log(inputJson);
        this.service.GetDashBoardModuleV2(inputJson).finally(()=>{
          setTimeout(()=>{
          this.activeSlider();

        },500)
        } )
        .subscribe(
          (result:any[])=>{

            if(result['Status']=="Success"){

                this.coachingModuleData=result['DashBoardData'];
               // console.log(this.coachingModuleData);


            } else {
              this.service.alert(result['Message'],"error")
            }
          },
          (error)=>{
           // console.log(error);
          }


        )
      }

      tremdingModuleData: any[] = [];

      getTrendingModule(){
        const inputJson={
        	"Type":"Trending",
        	"UserId":this.loginUserId
        }
       // console.log(inputJson);
        this.service.GetDashBoardModuleV2(inputJson).finally(()=>{
          setTimeout(()=>{
           this.activeTrendingSlider();
        },500)
        } )
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
                //this.coachingModuleData=result['DashBoardData'];
                this.tremdingModuleData=result['DashBoardData'];
               // console.log(this.tremdingModuleData);
            } else {
              this.service.alert(result['Message'],"error")
            }
          },
          (error)=>{
           // console.log(error);
          }
        )
      }

      addBookmark(pvarId,status) {
        if(this.loginUserId==-1){
            this.service.alert("Please login to use this feature","error");
          return false;
        } else {
          const inputJson = {
            	"ModuleId":pvarId,
            	"Status":status,
            	"UserId":this.loginUserId
          }

          if(status=="False"){
            inputJson.Status=true
          }
          else if(status=="True"){
            inputJson.Status=false
          }
           // console.log(inputJson);
            this.service.AddBookmark(inputJson)
            .subscribe(
              (result:any[])=>{
                if(result['Status']=="Success"){
                  if(inputJson.Status==true)
                  this.service.alert("Bookmark added successfully","success");
                  else
                  this.service.alert("Bookmark removed successfully","success");

                } else {
                  this.service.alert(result['Message'],"error");
                }

              },
              (error)=>{
               // console.log(error);
              },
              ()=>{

                this.coachingModuleData=[];

                setTimeout(()=>{

                  this.ngOnInit();
                },1000)


              }
            )
        }

      }

      // Harkamal Singh : Method to update meta tag
      updateMeta(){
        this.meta.updateTag({
    content: 'http://happcoach.com/PilotServices/Module/'+this.shareModuleId+'.html'
    },
   "property='og:url'"
    );
    this.shareLink="https://stratgist.com/Module/workSmarts-"+this.shareModuleId+".html"
    // this.shareLink="http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html"

      }
    // Harkamal Singh : Method to share to facebook,twitter,linkedin,g+
      shareToSocial(pvarChoice:number){
        if(pvarChoice==0){ // facebook
            window.open(
              "http://www.facebook.com/sharer/sharer.php?u="+this.shareLink,
              '_blank' // <- This is what makes it open in a new window.
            );
        }

        if(pvarChoice==1){//twitter
          window.open(
          "https://twitter.com/intent/tweet?url="+this.shareLink,
          '_blank'
        );
      }
        if(pvarChoice==2){//linkedin
          window.open(
          "https://www.linkedin.com/shareArticle?mini=true&url="+this.shareLink,
          '_blank'
        )
        }

        if(pvarChoice==3){//google plus
          window.open(
          "https://plus.google.com/share?url="+this.shareLink,
          '_blank'
        )
        }

      }

      getNumber(rating){
        return Math.round(rating);
      }

      reflectFeedbackChoice(choice:boolean){
        if(choice){
          this.areaFeedback=false;//Screen for yes / no to improve the area
          this.selectGoals=false; // Enable the screen to select max of 3 goals
          this.goalsCommitted=true;

        } else {
          // this.committedModal=true;
          this.areaFeedback=true;//Screen for yes / no to improve the area
          this.btnResult=false;
          this.setTabActive(5);
          this.selectGoals=false;//Screen to select max 3 goals
          return false;
        }
      }

      committedToGoals(){
        this.areaFeedback=false;
        this.selectGoals=false;
        this.goalsCommitted=false;//Screen to show committed or not committed

        let formValues=this.rForm.value;
       // console.log(formValues);
        if(formValues.Goals1=="" && formValues.Goals2=="" && formValues.Goals3==""){
          this.service.alert("Please enter your goals","error");
          this.myGoals=true;
          return false;
        } else {


          let myarr:any[]=[];
          var myObj={};

          if(formValues.Goals1!=""){
            var myObj={};
            myObj['GoalId']=-1
            myObj['GoalTitle']=formValues.Goals1;
            myObj['GoalChecked']=true;
            myObj['GoalCommitted']=true;
            myObj['GoalTime']="";

              myarr.push(myObj);
          }
          if(formValues.Goals2!=""){
            var myObj={};
            myObj['GoalId']=-1
          myObj['GoalTitle']=formValues.Goals2;
            myObj['GoalChecked']=true;
            myObj['GoalCommitted']=true;
            myObj['GoalTime']="";

              myarr.push(myObj);
          }
          if(formValues.Goals3!=""){
            var myObj={};
            myObj['GoalId']=-1
          myObj['GoalTitle']=formValues.Goals3;
            myObj['GoalChecked']=true;
            myObj['GoalCommitted']=true;
            myObj['GoalTime']="";

              myarr.push(myObj);
          }
         // console.log(myarr);
          for(var i=0;i<myarr.length;i++){
            for(var j=0;j<this.selectedGoals.length;j++){
              if(myarr[i]['GoalTitle']==this.selectedGoals[j]['GoalTitle']){
                myarr[i]['GoalId']=this.selectedGoals[j]['GoalId'];
              }
            }
          }

          this.selectedGoals=myarr
         // console.log(this.selectedGoals);
            this.myGoals=false;
          this.planForGoals=true;//screen to show time of goals


        }

      }

      newGoals(){ // Method to add new goal
        this.selectGoals=false;//Screen to select 3 goals max
        this.goalsCommitted=false;//Screen to show committed or not goals
        this.areaFeedback=false;//Screen to show the yes/no to improve the area
        this.myGoals=true;//Screen to add new goals

        for(var i=0;i<this.selectedGoals.length;i++){
            this.rForm.controls['Goals'+(i+1)].patchValue(this.selectedGoals[i]['GoalTitle']);
        }



      }

      commitGoal(choice:boolean){
        this.areaFeedback=false;
        this.selectGoals=false;
        this.myGoals=false;

        if(choice){
          this.committedModal=false;
          const inputJson= {
            "ModuleId":this.moduleId,
             "UserId":this.loginUserId
          }
         // console.log(inputJson);
          this.service.Getgoals(inputJson)
          .subscribe(
            (result:any[])=>{
              if(result['Status']=="Success"){
                 this.goals=[];
                 this.goals=result['GoalsDetails'];
                 for(let mygoal of this.goals){

                  mygoal['GoalCommitted']=true;


                 }

              } else {
                this.service.alert(result['Message'],"error");
              }
            },
            (error)=>{
             // console.log(error);
            }
          )
          this.selectGoals=true;

          this.goalsCommitted=false;
          for(var i=0;i<this.goals.length;i++){
            this.goals[i]['GoalCommitted']=true;
          }
        } else {
          this.committedModal=true;
          return false;

        }
      }

      setGoal(goal:{},index){
        this.goalCounter=0;
       // console.log(goal);

        this.goals[index].GoalChecked=!this.goals[index].GoalChecked;

        let goalselected:any[]=this.goals.filter(mygoal=>mygoal.GoalChecked==true);

        if(goalselected.length > 3){
            this.goals[index].GoalChecked=false;
            this.service.alert("You can select maximum of 3 goals","error");
            return false;
        }
        this.selectedGoals=goalselected.filter(mygoal=>mygoal.GoalChecked==true)
      }

      goToNextGoal(pvarChoice:number,count:number){
       // console.log(pvarChoice);
          this.selectedGoals[count]['GoalTime']=pvarChoice;
          if(pvarChoice==5 && count==this.selectedGoals.length-1){
            this.timelineModal=true;
            this.planForGoals=true;
            // this.actionPlan=true;
          }
        if(count==(this.selectedGoals.length-1)){

          this.areaFeedback=false;
          let GoalData:any[]=[];
            // this.actionPlan=true;
          let mygoal={};
          for(var i=0;i<this.selectedGoals.length;i++){
            mygoal={};
            mygoal['GoalId']=this.selectedGoals[i]['GoalId'];
            mygoal['GoalTime']=this.selectedGoals[i]['GoalTime'];
            mygoal['Title']=this.selectedGoals[i]['GoalTitle'];
            GoalData.push(mygoal);


          }
          let filteredArray=GoalData.filter(goal=>goal.GoalTime==5);
          if(filteredArray.length==this.selectedGoals.length){
            // this.planForGoals=true;

          this.timelineModal=true;
            return false;
            // alert("All are can't plan now");

          }else {
            if(GoalData[GoalData.length-1]['GoalTime']==5){

              this.planForGoals=true;
              this.actionPlan=false;
            }

            if(GoalData[GoalData.length-1]['GoalTime']!=5){

              this.planForGoals=false;
              this.actionPlan=true;
            }

          }
          const inputJson={
            "GoalData":GoalData,
            "HowCommitted":1,
	          "ModuleId":this.moduleId,
	          "UserId":this.loginUserId
          }
         // console.log(inputJson);
          this.service.AssignGoal(inputJson)
          .subscribe(
            (result:any[])=>{
              if(result['Status']=="Success"){
               // console.log("Goals assigned to you successfully");
                //this.service.alert("Goals assigned to you successfully","success");
              }else {
                this.service.alert(result['Message'],"error");
              }
            },
            (error)=>{
             // console.log(error);
            })
        }
        else{
         // console.log(this.selectedGoals);
          count+=1;
          this.goalCounter=count;
        }
      }

      addGoalTime(){

        if(this.selectedGoals.length ==0) {
          this.service.alert('Please select atleast 1 goal to continue','error');
          return false;
        }
        this.selectGoals=false;
        this.planForGoals=true;
      }

      updateUserCount(){
        this.userUpdated=true;
        const inputJson={
	        "ModuleId":this.moduleId
        }
        this.service.UpdateUserCount(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              sessionStorage.setItem('moduleId',JSON.stringify(this.moduleId))
              this.userUpdated=true;
            }else {
            this.userUpdated=false;
              this.service.alert(result['Message'],"error");
            }
          },
          (error)=>{
           // console.log(error);
           this.userUpdated=false;
          })

      }

      updateBadgeCount(e){
      this.badgeUnlocked=e;
      }

      getGoals(){
        const inputJson= {
          "ModuleId":this.moduleId,
           "UserId":this.loginUserId
        }
       // console.log(inputJson);
        this.service.Getgoals(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
               this.goals=[];
               this.goals=result['GoalsDetails'];
               this.isReflect=this.goals.length==0 ? false:true;

               for(let mygoal of this.goals){
                 if(mygoal['GoalChecked']==true){
                   this.actionPlan=true;
                   this.selectedGoals=this.goals;
                 } else {
                      mygoal['GoalCommitted']=true;
                      this.selectedGoals=[];
                 }

               }



            } else {
              this.service.alert(result['Message'],"error");
            }
          },
          (error)=>{
           // console.log(error);
          }
        )
      }

      goToResult(){
        this.timelineModal=false;
        this.setTabActive(5);
      }

      startOverFeedback(){
       // console.log(this.selectedGoals);


          this.planForGoals=false;
          this.areaFeedback=true;
          this.selectedGoals.forEach((obj)=>{
            obj.GoalChecked=false;
            obj.GoalTime="";
          })
          this.isHappyHover=false;



      }

      yesCommitTimeline(){
        this.planForGoals=false;
         this.actionPlan=true;
         this.timelineModal=false;
      }

      showShareWithDelay(){
        setTimeout(()=>{
          this.toggleSM=true;
        },500)
      }

      showActiveModule(pvarId){
        this.home.showActiveModule(pvarId);
      }

      commitModalChoice(choice){
        let goalsWithCantPlanNow:any[]=[];
        goalsWithCantPlanNow=this.selectedGoals.filter(goal=>goal.GoalTime==5);
        if(choice==true){
          if(goalsWithCantPlanNow.length==this.selectedGoals.length){
            this.timelineModal=false;
          this.goalsCommitted=false;
          this.selectGoals=false;
           this.myGoals=false ;
           this.planForGoals=false;
            this.actionPlan=false;
            this.areaFeedback=true;
            this.isHappyHover=false;
            this.selectedGoals=[];
            this.setTabActive(5);
          } else {
            this.yesCommitTimeline();
          }
          this.timelineModal=false;

        } else {
          this.timelineModal=false;
        }


      }

      goToModuleType(pvarType){
        if(pvarType=="Editor"){
          pvarType="Editor's Pick"
        }
        this._router.navigate(['/']).then(()=>{
          this._router.navigate(['all-modules',pvarType]);
        });
      }

      clickOnPaidModule(){
        if(this.loginUserId!=-1){

        if(localStorage.getItem("planId")=='-1' && this.isModuleFree==false){

          const inputJson={
            "ModuleId":this.moduleId,
            "UserId":this.loginUserId
          }
         // console.log(inputJson);
          this.service.ClickOnPaidModule(inputJson)
          .subscribe(
            (result:any[])=>{
             // console.log(result);
              if(result['Status']=="Success"){
               // console.log('free user click on paid module');
              }
              else{
                this.service.alert(result['Message'],"error");
              }
            },
            (error:Error)=>{
             // console.log(error);
            }
          )

        }

      }
      }

      freeActive(){
        this.freeTag=true;
        this.isLink=false;
      }

      freeInactive(){
        this.freeTag=false;
        this.isLink=true;
      }

      createTestUser(){
        if(sessionStorage.getItem('Guest') == null){
          if(Guest.isGuest==false){
            this.service.CreateTestUser().
            subscribe(
              (result:Response[])=>{
                this.guestUser=new Guest(result['Id']);
                sessionStorage.setItem('Guest',JSON.stringify(this.guestUser))
                if(this.guestUser!=null){
                  if(this.isAssigned==false && this.isCompleted==false){
                    this.assignModule(this.guestUser)
                  }

                }

              },
              (error)=>{
                // console.log(error);
              }
            )
          } else {
            return false
          }
        } else {
          this.guestUser=JSON.parse(sessionStorage.getItem('Guest'))
        }

        if(this.guestUser!=null){
          if(this.isAssigned==false && this.isCompleted==false){
            this.assignModule(this.guestUser)
          }

        }




      }



    }

    export class Guest {
      guestUserId:number=0;
      static isGuest:boolean=false;
      constructor(id:number){
        this.guestUserId=id;
        this.setGuest()
      }

      getGuest(){
        return this;
      }
      setGuest(){
        Guest.isGuest=true;
      }


    }



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/module-page/module-page.component.ts